<template>
  <div>

    <el-tabs type="border-card" v-model="card_index">
      <el-tab-pane label="模板列表" name="ApportionTemplateList">
        <ApportionTemplateList  v-if="card_index==='ApportionTemplateList'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ApportionTemplateList from "./ApportionTemplateList";

export default {
  name: "ApportionTemplateMain",
  components: {ApportionTemplateList},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      card_index:"ApportionTemplateList"
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/apportion_template/ApportionTemplateMain.vue